<template>
  <div class="lv-dialog-img-platform-stock">
    <v-dialog
      v-model="dialog"
      scrollable
      maxWidth="720px"
    >
      <v-card v-if="dialog">
        <v-card-title>
          <v-tabs>
            <v-tabs-slider></v-tabs-slider>
            <v-tab
              v-for="(tab,tabIndex) in tabs"
              :key="tabIndex"
              @click.stop.prevent="$_onTabClick(tab.value)"
            > {{tab.text}}
            </v-tab>
          </v-tabs>
        </v-card-title>

        <v-card-text>
          <div v-if="tab === 'select'">
            <WsCRUD
              pageMode
              rowClickEmit
              isMultiSelect
              :fields="fields"
              :showExpand="false"
              :isCreatable="false"
              :showTitlebar="false"
              :inRowBtnRead="false"
              :isFilterShow="false"
              :modelName="modelName"
              :inRowBtnUpdate="false"
              :inRowBtnDelete="false"
              :showFields="showFields"
              :hasMultiDeleteBtn="false"
              @row-click-item="$_onClickItem"
              @selected-changed="$_onSelectedChanged"
            />
          </div>
          <div v-if="tab === 'upload'">
            <WsBtn
              outlined
              minWidth="100px"
              color="textSecondary"
              :loading="isLoading.file"
              @click="$_onUpload"
            >選擇</WsBtn>
            <div
              v-if="!isLoading.file && files &&files.length > 0"
              class="mt-3"
            >
              <WsState
                v-model="files[0].title"
                required
                type="text"
                label="標題"
                rules="required"
                placeholder="輸入"
                class="mb-3"
              />
              <WsBtn
                outlined
                minWidth="100px"
                color="textSecondary"
                @click="$_onRemoveFile(0)"
              >
                {{ files[0].name }}
                <v-icon dark>
                  mdi-close-circle
                </v-icon>
              </WsBtn>
            </div>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <WsBtn
            outlined
            minWidth="100px"
            color="textSecondary"
            @click="$_onCancel"
          >取消</WsBtn>
          <WsBtn
            color="primary"
            minWidth="100px"
            @click="$_onSubmit"
          >送出</WsBtn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <input
      ref="fileInput"
      type="file"
      :accept="isChooseImage ? 'image/*' : ''"
      class="lv-dialog-img-platform-stock__input"
      @change="$_onChangeFile()"
    >
  </div>
</template>

<script>
import { isHeic, heicTo } from 'heic-to';
import imageCompression from 'browser-image-compression';
import S_platformStock from '@/services/api/v1/platformStock';
import H_file from '@/helpers/file';
import M_platformStock from '@/models/platformStock';

export default {
  props: {
    isChooseImage: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialog: false,
      tabs: [
        {
          text: '從檔案庫選擇',
          value: 'select',
        },
        {
          text: '上傳',
          value: 'upload',
        },
      ],
      tab: 'select',
      fileLimit: 30 * 1024 * 1024,
      isLoading: {
        file: false,
      },
      files: [],
      fields: M_platformStock.fields,
      modelName: M_platformStock.modelName,
      showFields: ['name', 'file_type'],
      selectedFiles: [],
    }
  },
  methods: {
    $_handleDialogClose() {
      this.close();
    },
    open() {
      this.dialog = true;
    },
    close() {
      this.files = [];
      this.selectedFiles = [];
      this.dialog = false;
      this.tab = 'select';
    },
    $_onCancel() {
      this.close();
    },
    async $_onSubmit() {
      try {
        if (this.tab === 'upload') {
          const formData = new FormData();
          formData.append('file', this.files[0].file);
          formData.append('name', this.files[0].title);
          const { source_url } = await S_platformStock.storeWithUpload(this.files[0].name, formData);
          this.files[0].url = source_url;
          this.$emit('input', this.files);
        } else {
          this.$emit('input', this.selectedFiles);
        }
        this.close();
      } catch (error) {
        alert('上傳失敗');
      }
    },
    $_onTabClick(tab) {
      this.tab = tab;
    },
    $_onUpload() {
      this.$refs.fileInput.value = null;
      this.$refs.fileInput.click();
    },
    async $_onChangeFile() {
      const files = this.$refs.fileInput.files;
      for (let fileIndex = 0; fileIndex < files.length; fileIndex++) {
        let file = files[fileIndex];
        if (this.isChooseImage && !file.type.startsWith('image/')) {
          alert('請選擇圖片');
          return;
        }
        if (file.size > this.fileLimit) {
          alert('檔案尺寸超過30MB');
          return;
        }
        if (file.type.startsWith('image/')) {
          this.isLoading.file = true;
          if ( await isHeic(file) ) file = await this.$_convertHeicToJpeg(file);
          file = await imageCompression(file, {
            maxSizeMB: 1,
            useWebWorker: true,
          });
          this.isLoading.file = false;
        }
        const selectedFile = {
          file,
          name: file.name,
          title: file.name,
          fileType: H_file.setFileExtension(file.name).slice(1),
          url: '',
        };
        if (this.multiple) this.files.push(selectedFile);
        else this.files = [selectedFile];
      }
    },
    async $_convertHeicToJpeg(file) {
      const dotIndex = file.name.lastIndexOf('.');
      const newName = (dotIndex !== -1)
        ? file.name.substring(0, dotIndex) + '.jpg'
        : file.name + '.jpg';
      const heicToJpg = await heicTo({
        blob: file,
        type: 'image/jpeg',
        quality: 1,
      });
      return new File([heicToJpg], newName, { type: 'image/jpeg' });
    },
    $_onRemoveFile(index) {
      this.files.splice(index, 1);
    },
    $_onClickItem($event) {
      const url = $event.source_url;
      window.open(url, '_blank');
    },
    $_onSelectedChanged($event) {
      this.selectedFiles = $event;
    }
  }
}
</script>

<style lang="scss">
  @import "../assets/scss/lv-dialog-img-platform-stock.scss";
</style>